import CommonService from './common.service'
import { _object } from 'utils/interfaces'

class MediaService extends CommonService {
  async uploadMediaData(params: _object) {
    return await this.post('/media', params)
  }
  async upDateMediaData(id: string, params: _object) {
    return await this.put(`/media/${id}`, params)
  }

  async deleteMediaData(id: string) {
    return await this.delete(`/media/${id}`)
  }
}

export const mediaService = new MediaService()
